export default __webpack_public_path__ + "static/media/14.0dbb05e5.svg";